import * as React from 'react';

const Truck24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1 15.25V6a2 2 0 0 1 1.999-2h11.993a2 2 0 0 1 1.999 2v2h3.455a2 2 0 0 1 1.986 1.78l.556 5.25A2 2 0 0 1 21 17.25h-2.26A2.75 2.75 0 0 1 15.99 20c-1.518 0-2.502-1.231-2.502-2.75H8.745a2.75 2.75 0 1 1-5.497 0h-.25a2 2 0 0 1-1.998-2m2.693.5a2.746 2.746 0 0 1 4.608 0h5.386a2.75 2.75 0 0 1 1.805-1.205V6a.5.5 0 0 0-.5-.5H2.999a.5.5 0 0 0-.5.5v9.25a.5.5 0 0 0 .5.5zm13.298-1.063c.538.21.993.586 1.304 1.063h2.706a.5.5 0 0 0 .496-.555L21.255 13H16.99v1.688Zm0-5.187v2h4.096l-.145-1.555a.5.5 0 0 0-.496-.445H16.99Zm-2.249 7.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m-9.995 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"
  }
));
Truck24.Size = 24;
Truck24.Title = "Truck";

export { Truck24 as default };
